import React from 'react';
import { db } from '../../firebase';
import AgentKingdom from '../../features/agents/AgentKingdom';

// Live: Grok Bot reports into Firestore through the CRM MCP server
// (functions/mcp/agents.js); the map listens with onSnapshot.
const CRMAgents = () => <AgentKingdom db={db} />;

export default CRMAgents;
